import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EstimateForm = _resolveComponent("EstimateForm")!
  const _component_RecalculationDialog = _resolveComponent("RecalculationDialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_EstimateForm, {
      onSave: _ctx.onSegmentSave,
      estimate: _ctx.estimate,
      "segment-configurations-factory": _ctx.createSegmentConfiguration
    }, null, 8, ["onSave", "estimate", "segment-configurations-factory"]),
    _createVNode(_component_RecalculationDialog, {
      "recalculation-handler": () => _ctx.model.recalculateWithNewEstates(),
      ref: "recalculationDialog"
    }, null, 8, ["recalculation-handler"])
  ]))
}